module.exports = __webpack_public_path__ + "static/media/spinSounds_1.f197f860.mp3";